import React from 'react';

import Carousel from '../components/Carousel';
import SectionHeader from '../components/SectionHeader';
import CategoriesSection from '../components/CategoriesSection';
import FreeShipping from '../components/FreeShipping';
import IndustriesSection from '../components/IndustriesSection';
import AboutSection from '../components/AboutSection';
import HomeParallaxSection from '../components/enquiry';
import NewsSection from '../components/NewsSection';
import ClientsEnquirySection from '../components/ClientsEnquirySection';

const slides = [
  {
    image: 'https://www.lffgroup.com/content/images/index/hp-sh-01_large.jpg',
    title: 'Manufacturing excellence for modern industry',
    subtitle: 'We design and build industrial machinery, automation and turnkey manufacturing solutions.',
    buttonText: 'View Products',
    buttonLink: '/products'
  },
  {
    image: 'https://www.lffgroup.com/content/images/index/hp-sh-02_large.jpg',
    title: 'Automation & Integration',
    subtitle: 'Custom automation solutions to increase throughput and quality.',
    buttonText: 'Contact Us',
    buttonLink: '/contact',
    buttonVariant: 'secondary'
  },
  {
    image: 'https://www.lffgroup.com/content/images/index/hp-sh-03_large.jpg',
    title: 'Custom Engineering Solutions',
    subtitle: 'Tailored engineering services for complex industrial challenges.',
    buttonText: 'Learn More',
    buttonLink: '/services',
    buttonVariant: 'secondary'
  },
  {
    image: 'https://www.lffgroup.com/content/images/index/hp-sh-04_large.jpg',
    title: 'Automation & Integration',
    subtitle: 'Custom automation solutions to increase throughput and quality.',
    buttonText: 'Contact Us',
    buttonLink: '/contact',
    buttonVariant: 'secondary'
  }
];

export default function Home() {
  return (
    <main>
      <Carousel slides={slides} />



      <CategoriesSection />

        <AboutSection />

     


      <HomeParallaxSection />

      <IndustriesSection />

      <ClientsEnquirySection />


      <NewsSection />

       <FreeShipping />

    

      
    </main>
  );
}
